<i
class="pi"
[pTooltip]="getStateLabel()"
[ngClass]="{
    'pi-check-circle text-success': isSuccess(),
    'pi-times-circle text-danger': isError(),
    'pi-info-circle text-info': isPending(),
    'pi-spinner fa-spin text-warning': isExecuting()
}"
></i>
